/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TemplateContextType {
    MissionByTicketDescription = 1,
    MissionByTaskDescription = 2,
    NoteForTicket = 3,
    NoteForMissionByTicket = 4,
    NoteForMissionByTask = 5,
    MissionDescription = 6,
    NoteForMission = 9,
    NoteBase = 11,
    MissionNotificationContent = 12,
    TicketNotificationContent = 13,
    InfoNotificationContent = 14,
    MissionNotificationSubject = 15,
    TicketNotificationSubject = 16,
    InfoNotificationSubject = 17,
    IssueEmailSubject = 18,
    IssueEmailContent = 19,
    MessageIssueEmailSubject = 181,
    TicketIssueEmailSubject = 182,
    MissionIssueEmailSubject = 183,
    TicketMailNodeEmailSubject = 186,
    OrderIssueEmailSubject = 188,
    ConnectedIssueEmailSubject = 189,
    MessageIssueEmailContent = 191,
    TicketIssueEmailContent = 192,
    MissionIssueEmailContent = 193,
    TicketMailNodeEmailContent = 196,
    OrderIssueEmailContent = 198,
    ConnectedIssueEmailContent = 199,
    IssueTitle = 200,
    CustomContainerRowTitle = 201,
}
